/* ZAFREN — drag-to-scroll for the theme's horizontal sliders (blog, product rows, categories).
   Touch already scrolls natively; this adds mouse/trackpad dragging and keeps snapping tidy. */
(function () {
  function enable(slider) {
    if (slider.dataset.zfDrag) return;
    slider.dataset.zfDrag = '1';
    slider.style.touchAction = 'pan-x pan-y';

    var down = false;
    var moved = false;
    var startX = 0;
    var startLeft = 0;
    var snap = '';
    var behavior = '';

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || slider.scrollWidth <= slider.clientWidth) return;
      down = true;
      moved = false;
      startX = e.pageX;
      startLeft = slider.scrollLeft;
      snap = slider.style.scrollSnapType;
      behavior = slider.style.scrollBehavior;
      e.preventDefault();
    });

    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto';
        slider.style.cursor = 'grabbing';
      }
      if (moved) slider.scrollLeft = startLeft - dx;
    });

    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      slider.style.cursor = '';
      if (!moved) return;
      /* Restore snapping so the strip settles on the nearest card. */
      slider.style.scrollBehavior = behavior;
      slider.style.scrollSnapType = snap;
    });

    /* A drag should not open the card underneath. */
    slider.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init(root) {
    (root || document).querySelectorAll('slider-component .slider, .slider.slider--mobile, .slider.slider--tablet, .slider.slider--everywhere').forEach(enable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
